//#region src/schema/localization/locales/zh-tw.ts
var e = {
	schema: {
		variants: "變體",
		discriminatorValue: "鑑別器值",
		noAllowedValues: "沒有值滿足此列舉限制。",
		example: "範例",
		examples: "範例",
		default: "預設值",
		schema: "結構描述",
		emptyObject: "空物件",
		showAdditionalProperties: "顯示附加屬性",
		showOneMoreProperty: "再顯示 1 個屬性",
		showMoreProperties: "再顯示 {count} 個屬性",
		forName: "對於 {name}",
		showSchemaDetails: "顯示結構描述詳細資訊",
		oneOf: "其中一個",
		anyOf: "任意一個",
		allOf: "全部",
		not: "非",
		unknownType: "未知類型",
		propertyCount: "屬性：{count}",
		headerCount: "標頭：{count}",
		recursiveReference: "遞迴參照 {name}",
		recursive: "遞迴",
		additionalProperties: "附加屬性",
		const: "常數",
		deprecated: "已棄用",
		discriminator: "鑑別器",
		enum: "列舉",
		format: "格式",
		greaterThan: "大於",
		keys: "鍵",
		lessThan: "小於",
		max: "最大值",
		min: "最小值",
		maxLength: "最大長度",
		minLength: "最小長度",
		multipleOf: "倍數",
		nullable: "可為 null",
		propertyNames: "屬性名稱",
		pattern: "模式",
		copyPattern: "複製模式",
		readOnly: "唯讀",
		required: "必填",
		hideValues: "隱藏值",
		showAllValues: "顯示所有值",
		type: "類型",
		unique: "唯一",
		values: "值",
		writeOnly: "唯寫",
		typeInteger: "整數。",
		formatInt32: "有號 32 位元整數（常用的整數型別）。",
		formatInt64: "有號 64 位元整數（long 型別）。",
		formatDate: "RFC 3339 第 5.6 節定義的 full-date 表示法，例如 2017-07-21",
		formatDateTime: "RFC 3339 第 5.6 節定義的 date-time 表示法，例如 2017-07-21T17:32:28Z",
		formatPassword: "提示介面遮蔽輸入內容",
		formatBase64: "base64 編碼的字元，例如 U3dhZ2dlciByb2Nrcw==",
		formatBinary: "二進位資料，用於描述檔案"
	},
	common: {
		copyDefault: "複製預設值",
		copyExample: "複製範例值"
	},
	actions: { copyLinkTo: "複製指向 {name} 的連結" }
};
//#endregion
export { e as zhTw };

//# sourceMappingURL=zh-tw.js.map